import { render, staticRenderFns } from "./LmTags.vue?vue&type=template&id=a5e5b17c&scoped=true&"
import script from "./LmTags.vue?vue&type=script&lang=js&"
export * from "./LmTags.vue?vue&type=script&lang=js&"
import style0 from "./LmTags.vue?vue&type=style&index=0&id=a5e5b17c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5b17c",
  null
  
)

export default component.exports